import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Navigate } from 'react-router-dom';
import { useCurrentUser } from 'src/hooks';
import SacPlusIcon from '../images/icons/sac-plus-fire-cart.svg?react';

export const UpgradeSuccess = () => {
  const { user } = useCurrentUser();
  const [status, setStatus] = useState(null);
  const [customerEmail, setCustomerEmail] = useState('');

  const { t } = useTranslation();

  const queryClient = useQueryClient();

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const sessionId = urlParams.get('session_id');

    fetch(
      `/api/subscribe/session-status?session_id=${sessionId}`,
      {
        method: 'GET',
        credentials: 'include',
      },
    )
      .then((res) => res.json())
      .then((data) => {
        setStatus(data.status);
        setCustomerEmail(data.customerEmail);

        // refetch the currentUser query so the users subscription status is updated
        queryClient.refetchQueries({ queryKey: ['currentUser'] });
      });
  }, [queryClient]);

  if (!user) return <Navigate to='/login' />;

  if (status === 'open') {
    return <Navigate to='/subscribe' />;
  }

  if (status === 'complete') {
    return (
      <div className='flex w-full flex-col items-center justify-center gap-6 bg-primary-dark px-4 py-12 xs:px-6 sm:px-10 sm:py-20 md:px-14 md:py-28'>
        <SacPlusIcon className='-ml-6 w-[270px]' />

        <div className='flex flex-col items-center justify-center gap-4'>
          <span className='text-center font-primary text-2xl font-bold text-skyBlue'>
            Share-A-Cart+
          </span>
          <span className='text-center font-primary text-4xl font-extrabold text-offWhite'>
            {t('upgrade.youve_been_upgraded')}
          </span>
          <p className='text-center font-secondary text-sm text-skyBlue'>
            {t('upgrade.a_confirmation_email_will_be_sent_to_customer_email', {
              customerEmail,
            })}
          </p>
        </div>

        {user.subscription.tier === 'personal' ? (
          <Link to='/plus/cart-history'>
            <button
              className='button-primary h-auto max-h-24 min-h-12 w-full max-w-[280px] whitespace-normal text-balance text-center'
              style={{ overflowWrap: 'anywhere' }}
            >
              {t('upgrade.view_full_cart_history')}
            </button>
          </Link>
        ) : (
          <Link to='/plus/your-org'>
            <button
              className='button-primary h-auto max-h-24 min-h-12 w-full max-w-[280px] whitespace-normal text-balance text-center'
              style={{ overflowWrap: 'anywhere' }}
            >
              Manage Your Organization
            </button>
          </Link>
        )}
      </div>
    );
  }

  return null;
};
